import React from 'react'
import { Box, Typography, Button, Hidden } from '@mui/material'
import { Navbar } from '../component/shared/Navbar'
import { StaffBenefitTable } from '../component/staff-benefit/StaffBenefitTable'
import { Helmet } from 'react-helmet-async'
import { AdminMenu } from '../component/admin/AdminMenu'
import { AdminXsMenu } from '../component/admin/AdminXsMenu'

export const StaffBenefitPanelScreen = () => {
  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Staff Benefit</title>
      </Helmet>

      <Navbar />
      <Box display={{ xs: 'block', md: 'flex' }}>
        <AdminMenu />
        <Box overflow='hidden' width='100%' sx={{ p: { xs: 1 } }} mb={{ xs: 2, md: 10 }}>
          <Box display='flex' my={3} justifyContent='space-between'>
            <Typography variant='h1'>Staff Benefits</Typography>
            <AdminXsMenu />
            <Hidden mdDown>
              <Button
                component='a'
                href='/create-staff-benefit'
                variant='contained'
                color='primary'
              >
                Create New Staff Benefit
              </Button>
            </Hidden>
          </Box>

          <Hidden mdUp>
            <Box mb={2}>
              <Button
                component='a'
                href='/create-staff-benefit'
                variant='contained'
                color='primary'
              >
                Create New Staff Benefit
              </Button>
            </Box>
          </Hidden>

          <StaffBenefitTable />
        </Box>
      </Box>
    </>
  )
}
